import { useEffect } from 'react';
import useApi from './useApi';
import { useEventStore } from '../context/EventContext';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import LatestVoyageDataFactory from '../factory/LatestVoyageDataFactory';
import { LatestVoyageDataBM } from '../types/BusinessModel/LatestVoyageDataBM';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setLatestVoyageData } = useEventStore();
    const { newLatestVoyageData } = LatestVoyageDataFactory();

    const getLatestVoyage = (imoNumber: number) => {
        getApiData({
            endpoint: apiEndpoints['getLatestVoyage'].url,
            queryParam: buildQueryParams({ imoNumber: imoNumber }),
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const latestVoyageDataBM = state.result as unknown as LatestVoyageDataBM;
            const latestVoyageData = newLatestVoyageData(latestVoyageDataBM);
            if (latestVoyageData) {
                setLatestVoyageData(latestVoyageData);
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getLatestVoyage };
};
